import { getProjectList } from './getProjectList';
import { setCurrentProject } from './setProject';

export function setFirstLoadProjects(projects, currentProject) {
  return dispatch => {
    dispatch(getProjectList(projects));
    dispatch(setCurrentProject(currentProject));
  };
}
